var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDraftLine = function SvgDraftLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.7 3a.9.9 0 0 1 .9.9v3.381l-1.8 1.8V4.8H6.2v14.4h12.6v-2.482l1.8-1.8V20.1a.9.9 0 0 1-.9.9H5.3a.9.9 0 0 1-.9-.9V3.9a.9.9 0 0 1 .9-.9zm1.6 6.127 1.273 1.273-7 7-1.275-.002.002-1.27zM13.4 12v1.8H8.9V12zm2.7-3.6v1.8H8.9V8.4z"
  })));
};
export default SvgDraftLine;